import { TimePicker as MuiTimepicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { Component } from "react";

class Timepicker extends Component {
	render() {
		return (
			<MuiTimepicker
				{...this.props}
				toolbarTitle=""
				okText="Ok"
				cancelText="Annuler"
				renderInput={(params) => {
                        if (!this.props.value) {
                            params.inputProps.value = "";
                        }
                        return (<TextField fullWidth={this.props.fullWidth} {...params} />);
                    }
                }
			/>
		);
	}
}

export default Timepicker;
